import { DIRECT_STEP_TITLE } from './constants';

export const toQuery = (params) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      search.append(key, String(value).trim());
    }
  });
  const query = search.toString();
  return query ? `?${query}` : '';
};

export const linesToArray = (text) =>
  (text || '')
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0);

export const arrayToLines = (arr) => (Array.isArray(arr) ? arr.join('\n') : '');

export const readErrorMessage = (error) =>
  error?.error_message ||
  error?.message ||
  error?.detail ||
  'Something went wrong';

export const directTextToPayload = (text) => {
  const trimmed = (text || '').trim();
  if (!trimmed) return [];
  return [{ title: DIRECT_STEP_TITLE, step_number: 1, guidelines: [trimmed] }];
};

export const stepsToPayload = (steps) =>
  (steps || [])
    .map((step) => ({
      title: (step.title || '').trim(),
      guidelines: linesToArray(step.content),
    }))
    .filter((step) => step.guidelines.length > 0)
    .map((step, idx) => ({ ...step, step_number: idx + 1 }));

export const payloadToSteps = (arr) =>
  (arr || [])
    .slice()
    .sort((a, b) => (a.step_number || 0) - (b.step_number || 0))
    .map((entry, idx) => ({
      title: entry.title || '',
      stepNumber: entry.step_number || idx + 1,
      content: arrayToLines(entry.guidelines),
    }));

export const isDirectPayload = (arr) =>
  Array.isArray(arr) &&
  arr.length === 1 &&
  (arr[0]?.title === DIRECT_STEP_TITLE ||
    (arr[0]?.guidelines || []).length <= 1);

const pickGuidelineBucket = (parsed) => {
  if (parsed?.target_group || parsed?.control_group) {
    return parsed.target_group || parsed.control_group;
  }
  return parsed;
};

const buildBuilderFromArray = (arr) => {
  if (Array.isArray(arr) && arr.length > 0) {
    if (isDirectPayload(arr)) {
      return {
        mode: 'direct',
        directText: (arr[0].guidelines || []).join('\n'),
        steps: [],
      };
    }
    return { mode: 'step', directText: '', steps: payloadToSteps(arr) };
  }
  return null;
};

export const parseGuidelineObject = (parsed) => {
  const source = parsed || {};
  const bucket = pickGuidelineBucket(source) || {};
  return {
    lookupType: source.lookup_type || bucket.lookup_type || null,
    lookupId: source.lookup_id || bucket.lookup_id || null,
    rolloutGroup: bucket.rollout_group || null,
    summaryBuilder: buildBuilderFromArray(bucket.media_summarization_guidelines),
    verificationBuilder: buildBuilderFromArray(
      bucket.step_by_step_verification_guidelines,
    ),
  };
};

export const parseGuidelineImport = (rawJson) =>
  parseGuidelineObject(JSON.parse(rawJson));
